// Phase A palette for the "draw the space" step (#5). Two categories:
//   • furniture/architecture — visualization only
//   • existing — survey of what's already installed (flows into the lead)
// Council decision (2026-06-19): tap-to-place fixed-size emoji icons, plain PT
// labels, ~8 furniture + ~9 existing + "Outro" (free note). No custom SVGs in
// Phase A — emoji ship fast and render crisp on mobile.
import type { DecorCategory } from '../store/wizardStore';

export interface PaletteItem {
  type: string;
  label: string;
  icon: string; // emoji glyph
}

export const FURNITURE: PaletteItem[] = [
  { type: 'porta', label: 'Porta', icon: '🚪' },
  { type: 'janela', label: 'Janela', icon: '🪟' },
  { type: 'sofa', label: 'Sofá', icon: '🛋️' },
  { type: 'mesa', label: 'Mesa', icon: '🪑' },
  { type: 'cama', label: 'Cama', icon: '🛏️' },
  { type: 'tv', label: 'TV', icon: '📺' },
  { type: 'armario', label: 'Armário', icon: '🗄️' },
  { type: 'planta', label: 'Planta', icon: '🪴' },
];

export const EXISTING: PaletteItem[] = [
  { type: 'tomada', label: 'Tomada', icon: '🔌' },
  { type: 'interruptor', label: 'Interruptor', icon: '🔘' },
  { type: 'quadro', label: 'Quadro elétrico', icon: '⚡' },
  { type: 'ac', label: 'Ar condicionado', icon: '❄️' },
  { type: 'termostato', label: 'Termóstato', icon: '🌡️' },
  { type: 'videoporteiro', label: 'Videoporteiro', icon: '🛎️' },
  { type: 'alarme', label: 'Alarme / Sensor', icon: '🚨' },
  { type: 'camera', label: 'Câmara', icon: '📷' },
  { type: 'router', label: 'Router / Internet', icon: '📶' },
  { type: 'outro', label: 'Outro', icon: '➕' },
];

const ALL = [...FURNITURE, ...EXISTING];
export function paletteIcon(type: string): string {
  return ALL.find((p) => p.type === type)?.icon ?? '📍';
}
